import React, { useMemo } from 'react';
import type { Reference } from 'sr-types/lib/search/v1/graphql';
import type { EntityName, EntitySecurity } from '../common/auth/Security';
import { EntitySecurityProvider, FeatureSecurityProvider } from '../common/auth/Security';
import { FEATURE_CONSTANTS } from '../common/constants/featureConstants';
import { useI18n } from '../common/i18n/I18n';
import Notes from '../common/notes/Notes';

type MarketplaceEngagementNoteDetailsProps = {
    id: string;
    noteId: string;
    entity: EntityName;
    entitySecurity: EntitySecurity;
    entityReference: Reference;
    onClose: () => void;
};

export default function MarketplaceEngagementNoteDetails({
    id,
    noteId,
    entity,
    entitySecurity,
    entityReference,
    onClose
}: MarketplaceEngagementNoteDetailsProps) {
    const t = useI18n();

    const notesElement = useMemo(
        () => (
            <Notes
                id={id}
                title={t('note.panel.title')}
                onClose={onClose}
                entity={entity}
                entityReference={entityReference}
                highlightedNoteId={noteId}
                singleNoteView={{ noteId, disableEditing: true }}
                hideSearchAndEditor
                renderWithoutSidePanel
            />
        ),
        [entity, entityReference, id, noteId, onClose, t]
    );

    return (
        <FeatureSecurityProvider featureName={FEATURE_CONSTANTS.marketplace}>
            <EntitySecurityProvider entityName={entity} entitySecurity={entitySecurity}>
                {notesElement}
            </EntitySecurityProvider>
        </FeatureSecurityProvider>
    );
}
